import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialerService {
  isDialerVisible: boolean = true;
  waitingForCallToComplete: boolean = false;
  IsTransferCallRejected: boolean = false;
  CurrentTransferStep: number = 0;
  transferStatus: number;
  isDialerCancelledStatus: boolean = false;
  isCallTransferstarted: boolean = false;
  IsBlockLoader: boolean = false;
    IsCaseDetailFreeDial: boolean = false;
    IsAgentStatusChangeRequired: boolean = false;
    isStatusModalOpen: boolean = false;
  currentUserRecordInfo: any;
  enableFreeDialer: boolean=true;
  constructor() {}
  public statusMessage: BehaviorSubject<string> = new BehaviorSubject<string>('Waiting for call (Ready)');
  public phoneNo: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public ivrUserID: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public waitingForInboundCall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showCustomDialer: BehaviorSubject<boolean> = new BehaviorSubject<any>(null);
  public showDialer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public HideTransferDialogWindow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public callDisconnected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public callConnected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public muteMic: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showTimer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showCallDuration: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public deviceReady: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public connections: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public holdCallDuration: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public onHold: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public resumeCall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public resetTimer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public callEnded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isOutboundCallStarted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public dialerMessage: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public resetCallSummary: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isDialerCancel: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isResumeCalling: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public CallID: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public callStatus: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public userStatus: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public IsFreeDialer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public callDuration: any;
  public isCaseLocked: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isEnableAddNewNumber: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public IsSaveUserRecord: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public phoneNumberType: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public accumulatedHoldSeconds: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public stopHoldTimer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private predictiveModal = new BehaviorSubject<boolean>(false);
	isPredictiveModalOpen$ = this.predictiveModal.asObservable();

  setPredictiveModalState(isOpen: boolean) {
		this.predictiveModal.next(isOpen);
	}

  getDialerCancelledStatus() {
    return this.isDialerCancelledStatus;
  }
  setDialerCancelledStatus(val: boolean) {
    this.isDialerCancelledStatus = val;
  }

  setStopHoldTimer(val: boolean) {
    this.stopHoldTimer.next(val);
  }

  setHoldCallDuration(val: string){
    this.holdCallDuration.next(val);
  }

  setResetCallSummary(val: boolean) {
    this.resetCallSummary.next(val);
  }
  getCurrentTransferStep() {
    return this.CurrentTransferStep;
  }
  setCurrentTransferStep(val: number) {
    this.CurrentTransferStep = val;
  }
  getCurrentStatusid() {
    return this.transferStatus;
  }
  setCurrentStatusid(val: number) {
    this.transferStatus = val;
  }
  getisCallTransferstarted() {
    return this.isCallTransferstarted;
  }
  setisCallTransferstarted(val: boolean) {
    this.isCallTransferstarted = val;
  }
  setStatusMessage(value: string) {
    this.statusMessage.next(value);
  }

  setdialerMessage(value: string) {
    this.dialerMessage.next(value);
  }

  setPhoneNo(value: string) {
    this.phoneNo.next(value);
  }

  setWaitingForInboundCall(value: boolean) {
    this.waitingForInboundCall.next(value);
  }

  setShowDialer(value: boolean) {
    this.showDialer.next(value);
  }

  setHideTransferDialogWindow(value: boolean) {
    this.HideTransferDialogWindow.next(value);
  }

  setCustomShowDialer(value: any) {
    this.showCustomDialer.next(value);
  }

  setcallEnded(value: boolean) {
    this.callEnded.next(value);
  }

  setisOutboundCallStarted(val: any) {
    this.isOutboundCallStarted.next(val);
  }
  setCallDisconnected(value: boolean) {
    this.callDisconnected.next(value);
  }
  getCallDisconnected() {
    return this.callDisconnected.value;
  }

  setCallConnected(value: boolean) {
    this.callConnected.next(value);
  }
  getCallConnected(value: boolean) {
    return this.callConnected.value;
  }
  setshowTimer(value: boolean) {
    this.showTimer.next(value);
    }

    setshowCallDuration(value: boolean) {
        this.showCallDuration.next(value);
    }
  setMuteMic(value: boolean) {
    this.muteMic.next(value);
  }

  setDeviceReady(value: boolean) {
    this.deviceReady.next(value);
  }

  setConnections(value: boolean) {
    this.connections.next(value);
  }

  setOnHold(value: boolean) {
    this.onHold.next(value);
  }

  setResumeCall(value: boolean) {
    this.resumeCall.next(value);
  }

  setResetTimer(value: boolean) {
    this.resetTimer.next(value);
  }

  isDialerPadVisible() {
    return this.isDialerVisible;
  }
  setDialerPadVisible(dailer: boolean) {
    this.isDialerVisible = dailer;
  }
  getEnableFreeDialer()
  {
    return this.enableFreeDialer
  }
  setEnableFreeDialer(value)
  {
    this.enableFreeDialer=value
  }
  setDialerCancel(val: boolean) {
    this.isDialerCancel.next(val);
  }
  setResumeCalling(val: boolean) {
    this.isResumeCalling.next(val);
  }

  setwaitingForCallToComplete(val: boolean) {
    this.waitingForCallToComplete = val;
  }
  getwaitingForCallToComplete() {
    return this.waitingForCallToComplete;
  }

  setIsTransferCallRejected(val: boolean) {
    this.IsTransferCallRejected = val;
  }
  getIsTransferCallRejected() {
    return this.IsTransferCallRejected;
  }
  getPhoneNo() {
    return this.phoneNo.value;
  }
  getCallStatus() {
    return this.callStatus.value;
  }
  setCallStatus(status: string) {
    this.callStatus.next(status);
  }
  getCaseLock() {
    return this.isCaseLocked.value;
  }
  setCaseLock(value){
  this.isCaseLocked.next(value);
  }

  getUserStatus() {
    return this.userStatus.value;
  }
  setUserStatus(status: string) {
    this.userStatus.next(status);
  }
  setIsFreeDialer(flag: boolean) {
    this.IsFreeDialer.next(flag);
  }
  getIsFreeDialer() {
    return this.IsFreeDialer.value;
  }
  setCallDuration(duration: string) {
    this.callDuration = duration;
  }
  setIVRUserID(userID: number) {
    this.ivrUserID.next(userID);
  }
  
  getCallDuration() {
    return this.callDuration;
  }
  setIsEnableAddNewNumber(flag: boolean) {
    this.isEnableAddNewNumber.next(flag);
  }
  getIsEnableAddNewNumber() {
    return this.isEnableAddNewNumber.value;
  }
  setIsSaveUserRecord(flag: boolean) {
    this.IsSaveUserRecord.next(flag);
  }
  getIsSaveUserRecord() {
    return this.IsSaveUserRecord.value;
  }
  setaccumulatedHoldSeconds(val: number){
    this.accumulatedHoldSeconds.next(val);
  }
  setphoneNumberType(type: string) {
    this.phoneNumberType.next(type);
  }
  getphoneNumberType() {
    return this.phoneNumberType.value;
  }
  getsoftphoneCancelledStatus() {
    return this.isDialerCancel.value;
  }

  setIsBlockLoader(flag: boolean) {
    this.IsBlockLoader = flag;
  }
  getIsBlockLoader() {
    return this.IsBlockLoader;
  }

  getIsCaseDetailFreeDial()
  {
    return this.IsCaseDetailFreeDial;
  }
  setIsCaseDetailFreeDial(value)
  {
    this.IsCaseDetailFreeDial=value;
  }

  setCurrentUserRecord(value)
  {
    this.currentUserRecordInfo=value
  }
  getCurrentUserRecord()
  {
    return this.currentUserRecordInfo
    }

    getIsAgentStatusChangeRequired() {
        return this.IsAgentStatusChangeRequired;
    }
    setIsAgentStatusChangeRequired(value: boolean) {
        this.IsAgentStatusChangeRequired = value;
    }

    getIsStatusModalOpen() {
        return this.isStatusModalOpen;
    }
    setIsStatusModalOpen(value: boolean) {
        this.isStatusModalOpen = value;
    }
}
